// HomeRedirect.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'features/auth/AuthContext';

const HomeRedirect = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    console.log("🚀 ~ HomeRedirect ~ isAuthenticated:", isAuthenticated)

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/connect');
        } else {
            navigate('/login');
        }
    }, [isAuthenticated, navigate]);

    return null; // You can show a loader here if needed
};

export default HomeRedirect;
